import { EmailsResend, SupportEmail } from "../emailTypes"
import { useDateTime } from "../../../../../localization/useDateTime"
import { Box, Grid, Typography, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { Button } from "../../../../../office/admin/components/Button"
import { ResendDialog } from "./ResendDialog"
import { useState } from "react"
import { useResendEmail } from "../hooks/useResendEmail"

const useStyles = makeStyles()(() => ({
    textGray: {
        color: tailwindPalette.gray[500],
    },
    bodyContainer: {
        padding: "2rem",
        marginTop: "2rem",
        minHeight: "10rem",
        backgroundColor: tailwindPalette.gray[50],
        width: "60%",
    },
}))

export function DetailedPanel({ data }: { data: SupportEmail }) {
    const { status, sentTime, history, sender, subject, receiver, body } = data
    const { classes } = useStyles()
    const [showModal, setShowModal] = useState(false)

    const dateTimeFactory = useDateTime()

    const { mutate } = useResendEmail()

    const resendEmail = (resendEmailData: EmailsResend["receiver"]) => {
        mutate({
            emails: [
                {
                    id: data.id,
                    receiver: { ...resendEmailData },
                },
            ],
        })
        setShowModal(false)
    }
    return (
        <Stack direction="column" spacing="1rem">
            <Grid container justifyContent="space-between">
                <Stack direction="row" spacing="1.5rem">
                    <Stack direction="row" spacing=".5rem">
                        <LocalizedStrict id="support-messages-email-details-status-label">
                            <Typography className={classes.textGray}>Status:</Typography>
                        </LocalizedStrict>
                        <Typography>{status.text}</Typography>
                    </Stack>
                    <Stack direction="row" spacing=".5rem">
                        <LocalizedStrict id="support-messages-email-details-created-label">
                            <Typography className={classes.textGray}>Created:</Typography>
                        </LocalizedStrict>
                        <Typography>
                            {dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(history.created))}
                        </Typography>
                    </Stack>
                    <Stack direction="row" spacing=".5rem">
                        <LocalizedStrict id="support-messages-email-details-sent-time-label">
                            <Typography className={classes.textGray}>Sent time:</Typography>
                        </LocalizedStrict>
                        <Typography>{dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(sentTime))}</Typography>
                    </Stack>
                </Stack>
                <LocalizedStrict id="support-messages-email-details-resend-email-button">
                    <Button onClick={() => setShowModal(true)}>Resend email</Button>
                </LocalizedStrict>
            </Grid>

            {status?.errorDetails && (
                <Grid container direction="column">
                    <LocalizedStrict id="support-messages-email-details-error-message-label">
                        <Typography className={classes.textGray}>Error message:</Typography>
                    </LocalizedStrict>
                    <Typography>{status.errorDetails.message}</Typography>
                </Grid>
            )}

            <Stack direction="column" spacing=".3rem">
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-email-details-from-label">
                            <Typography className={classes.textGray}>From:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{sender}</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-email-details-subject-label">
                            <Typography className={classes.textGray}>Subject:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{subject}</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-email-details-to-label">
                            <Typography className={classes.textGray}>To:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{receiver.to}</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-email-details-cc-label">
                            <Typography className={classes.textGray}>CC:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{receiver.cc}</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-email-details-bcc-label">
                            <Typography className={classes.textGray}>BCC:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{receiver.bcc}</Typography>
                    </Grid>
                </Grid>
            </Stack>
            <Grid container justifyContent="center">
                <Box className={classes.bodyContainer}>{body}</Box>
            </Grid>

            {showModal && (
                <ResendDialog
                    open={showModal}
                    onClose={() => setShowModal(false)}
                    handleClick={(data) => resendEmail(data)}
                    data={data}
                />
            )}
        </Stack>
    )
}
